import { createContext, Context } from 'react';
import { NotificationController } from 'providers/notification/notification.controller';

export const NotificationContext: Context<NotificationController> = createContext<NotificationController>(new NotificationController());